import React, { useState, useEffect } from 'react';
import { Card, CardContent } from '@mui/material';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';

import { StatusHistory } from '../../../developerModules/model';

import IconCardHeader from '../../../sharedModules/layout/IconCardHeader';
import StepResultsList from '../../../developerModules/callbackResults/StepResultsList';
import StepSummaryChip from '../../../developerModules/callbackResults/StepSummaryChip';

import axios from '../../../sharedModules/utils/axios.utils';

const ApprovalAutomationsSection: React.FC<{ backflowJobGroupId: string }> = ({ backflowJobGroupId }) => {
  const [history, setHistory] = useState<StatusHistory | null>(null);
  const [loading, setLoading] = useState(true);

  const fetchHistory = async () => {
    try {
      const response = await axios.get<any>('/status_callback_audits', {
        params: {
          'ransack[record_type_eq]': 'BackflowJobGroup',
          'ransack[record_id_eq]': backflowJobGroupId,
          'ransack[new_status_eq]': 'approved',
          per_page: 1,
        },
      });
      const histories = response.data.result ?? [];
      setHistory(histories.length > 0 ? histories[0] : null);
    } catch {
      setHistory(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchHistory();
  }, [backflowJobGroupId]);

  if (loading) return null;
  if (!history) return null;

  return (
    <Card elevation={3}>
      <CardContent>
        <IconCardHeader
          icon={AutoFixHighIcon}
          title="Automation Results"
          action={<StepSummaryChip success={history.success} />}
        />

        <StepResultsList steps={history.step_results_titleized} />
      </CardContent>
    </Card>
  );
};

export default ApprovalAutomationsSection;
